import React, { useState, useEffect } from 'react';
import { useSite } from '../../context/SiteContext';
import { motion, AnimatePresence } from 'framer-motion';

const proofData = [
  { name: 'Rachel H.', location: 'Charlotte, NC', product: '1 Month Supply', time: '6 mins ago' },
  { name: 'Michael T.', location: 'Austin, TX', product: '3 Month Supply', time: '12 mins ago' },
  { name: 'Daniel K.', location: 'San Diego, CA', product: '6 Month Supply', time: '18 mins ago' },
  { name: 'Jared P.', location: 'Tampa, FL', product: '3 Month Supply', time: '24 mins ago' },
];

export const FloatingProof = () => {
  const { settings } = useSite();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show first proof after 5 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(initialTimer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    // Cycle through proofs every 8 seconds
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % proofData.length);
        setIsVisible(true);
      }, 500);
    }, 8000);

    return () => clearInterval(interval);
  }, [isVisible]);

  const currentProof = proofData[currentIndex];

  return (
    <div className="floating-proof hidden md:block">
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 50, scale: 0.9 }}
            transition={{ duration: 0.3 }}
            className="rounded-2xl bg-white border border-slate-200 shadow-xl p-4 flex items-center gap-4 max-w-sm"
          >
            <div
              className="w-14 h-14 rounded-xl flex items-center justify-center font-heading font-bold text-white text-xl"
              style={{ backgroundColor: settings?.primary_color || '#1e3a8a' }}
            >
              {currentProof.name.charAt(0)}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-bold truncate">
                {currentProof.name} from {currentProof.location}
              </div>
              <div className="text-xs text-slate-600 truncate">
                Purchased {settings?.site_name || 'Boostaro'} {currentProof.product}
              </div>
              <div className="mt-1 flex items-center gap-2 text-xs text-slate-500">
                <span>{currentProof.time}</span>
                <span className="flex items-center gap-1">
                  <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                  Verified
                </span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingProof;
